import { A } from "@/atoms-react/a/A.react";
import Loader from "@/atoms-react/loader/Loader.react";
import { Base } from "@/atoms-react/text/Text.react";
import { DocumentArrowDownIcon } from "@heroicons/react/24/solid";
import type React from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export type DragAndDropProps = {
  onValidated?: (files: FileList | null) => void;
  isLoading?: boolean;
  disabled?: boolean;
} & React.ComponentPropsWithoutRef<"div">;

export const DragAndDrop = ({
  className,
  isLoading,
  onValidated = () => {},
  disabled = false,
  ...props
}: DragAndDropProps) => {
  // const [files, setFiles] = useState<FileList | null>(null)
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation(["pass"]);

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => event.preventDefault();

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();

    if (!event?.dataTransfer?.files || disabled) return;

    // setFiles(event.dataTransfer.files)
    onValidated(event.dataTransfer.files);
  };
  return (
    <div
      className={twMerge(
        "flex h-auto flex-col items-center justify-center rounded-sm border-2 border-slate-100 border-dashed p-6",
        className
      )}
      onDragOver={(event) => handleDragOver(event)}
      onDrop={handleDrop}
      {...props}
    >
      {isLoading && <Loader />}
      {!isLoading && (
        <>
          <DocumentArrowDownIcon className="h-12 w-12 min-w-12 text-slate-300 md:mb-3" />
          <Base disabled={disabled} className="text-center">
            <A
              data-cy="button-upload-doc"
              disabled={disabled}
              onClick={() => {
                if (!inputRef.current) return;
                inputRef.current.click();
              }}
            >
              {t("aliasDocumentsPage.button")}
            </A>
            <span> {t("aliasDocumentsPage.button_label")} </span>
          </Base>
          <input
            type="file"
            data-cy="input-upload-doc"
            disabled={disabled}
            onChange={(event) => {
              if (!disabled) {
                onValidated(event.target.files);
              }
            }}
            hidden
            ref={inputRef}
          ></input>
        </>
      )}
    </div>
  );
};
